import React from "react";

import { FormField, type FormFieldProps } from "~/components/form/field";
import { cx } from "~/tools/class-variance";
import type { ImpulseForm } from "~/tools/impulse-form";

// The grid has the second row reserved for error messages
export const SettingsSectionFormField = <TForm extends ImpulseForm>({ className, ...props }: FormFieldProps<TForm>) => (
	<FormField {...props} className={cx("col-span-full grid grid-cols-subgrid grid-rows-[1fr_auto]", className)} />
);
